"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStaticRuntime = exports.isOfficialRuntime = void 0;
/*
 * Helper function to support both `@vercel` and legacy `@now` official Runtimes.
 */
const isOfficialRuntime = (desired, name) => {
    if (typeof name !== 'string') {
        return false;
    }
    return (name === `@vercel/${desired}` ||
        name === `@now/${desired}` ||
        name.startsWith(`@vercel/${desired}@`) ||
        name.startsWith(`@now/${desired}@`));
};
exports.isOfficialRuntime = isOfficialRuntime;
/*
 * Helper function to detect both `@vercel/static` and legacy `@now/static` official Runtimes.
 */
const isStaticRuntime = (name) => {
    return (0, exports.isOfficialRuntime)('static', name);
};
exports.isStaticRuntime = isStaticRuntime;
//# sourceMappingURL=is-official-runtime.js.map